import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'

import Nprogress from 'nprogress';
import globalAxios from 'axios'

import router from '@/router/index'
import qs from 'qs'
Vue.use(Vuex)
const state = {
    account_setting_list: [],
    add_location: [],
    myZoneDetailsList: [],
    myZonePermissionsList: []
}
const mutations = {
    DELETE_SESSIONS(state, data) {
        var sessions = data.sessions;
        var accountId = data.accountId;
    
        if (Object.keys(state.ordersList).length != 0) {
          for (var i = 0; i < orderIds.length; i++) {
            var index = state.ordersList[accountId + "-ordersList"].findIndex(order => order.PurchaseOrder.id == orderIds[i]);
            state.ordersList[accountId + "-ordersList"].splice(index, 1)
          }
        }
    },
      
    SET_ACCOUNT_SETTING_DATA(state, data) {
        state.account_setting_list = data
    },
    DELETE_ADMIN_IP(state, deleteId) {
        var index = state.account_setting_list.adminIps.findIndex(Element => Element.AdminIp.id == deleteId);
        state.account_setting_list.adminIps.splice(index, 1);
    },
    ADD_NEW_ADMIN_IP(state, addip) {
        state.account_setting_list.adminIps.push(addip);
    },
    ADD_LOCATION(state, data) {
        state.add_location = data;
    },
    CLEAR_ACCOUNT_SETTING_STATE(state) {
        state.account_setting_list = [];
        state.add_location = [];
    },
    SET_MY_ZONE_LIST(state, userData) {
        var tData = {};
        var parseData = JSON.parse(userData.message);
        state.myZonePermissionsList = userData.permissions;
        state.myZoneDetailsList = [];

        if (parseData != null) {
            tData[userData.accountId + '-myZoneDetailsList'] = parseData;
            state.myZoneDetailsList = tData;
        }
    }
    
    
}
const actions = {
    fetchAccountSettingData({
        commit,
        dispatch
    }, authData) {
        Nprogress.start();
        if (authData.adminId == undefined || authData.accountId == undefined) {
            axios.get('/account_settings/account_setting_list')
                .then(res => {
                    Nprogress.done()
                    commit("SET_ACCOUNT_SETTING_DATA", res.data.message);
                })
                .catch(error => console.log(error))
        } else {

            axios.get('/account_settings/account_setting_list/' + authData.adminId + '/' + authData.accountId)
                .then(res => {
                    Nprogress.done()
                    commit("SET_ACCOUNT_SETTING_DATA", res.data.message);
                })
                .catch(error => console.log(error))
        }

    },
    sendAccountSettingData({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/AccountSettings/edit_admin.json', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    allowIPAddress({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/AccountSettings/add_admin_ip', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    commit("ADD_NEW_ADMIN_IP", response.data.newIp);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    deleteAdminIPAddress({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/AccountSettings/del_admin_ip', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    commit("DELETE_ADMIN_IP", postData.adminIpId)
                    resolve(response.data);

                })
                .catch(error => console.log(error));
        });
    },
    deleteProfile({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/AccountSettings/delete_admin_profile_image', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);

                })
                .catch(error => console.log(error));
        });
    },
    changePassword({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/account_settings', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);

                })
                .catch(error => console.log(error));
        });
    },
    uploadProfilePicture({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios
                .post("AccountSettings/upload_profile_image_vue", postData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);

                })
                .catch(error => console.log(error));
        });
    },
    inventoryQuantity({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/inventory/get_quantity_type', qs.stringify(postData, {
                parseArrays: false,
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);

                })
                .catch(error => console.log(error));
        });
    },
    inventoryUsersLocation({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/inventory/get_account_users_and_locations', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);

                })
                .catch(error => console.log(error));
        });
    },
    getUsersLocation({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/users/get_account_users_and_locations', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);

                })
                .catch(error => console.log(error));
        });
    },
    submitTransferItem({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            /// console.log("store postdata",postData);
            axios.post('/inventory/transfer_item', postData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);

                })
                .catch(error => console.log(error));
        });
    },
    allowableAccounts({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/AccountSettings/save_allowable_accounts', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    commit("ADD_LOCATION", response.data.data);
                    resolve(response.data);

                })
                .catch(error => console.log(error));
        });
    },
    clearAccountSettingState({
        commit,
        dispatch
    }) {
        commit('CLEAR_ACCOUNT_SETTING_STATE')
    },
    addLocationForm({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/inventory/manage_locations', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    commit("ADD_LOCATION", response.data.data);
                    resolve(response.data);

                })
                .catch(error => console.log(error));
        });
    },
    fetchMyZoneDetailsList({
        commit,
        dispatch
    }, authData) {
        Nprogress.start()
        return new Promise((resolve, reject) => {
            axios.get('/account_settings/get_all_my_zone_detail/' + authData.accountId + "/" + authData.level + "/" + true + '/' + authData.limit + '/' + authData.page + '/' + authData.search + '/' + authData.sorting)
                .then(res => {
                    Nprogress.done()
                    commit('SET_MY_ZONE_LIST', res.data)
                    resolve(res.data);
                })
                .catch(error => console.log(error))
        });
    },
    deleteSelectedSessions({
        commit,
        dispatch
      }, postData) {
        return new Promise((resolve, reject) => {
    
          let loader = Vue.$loading.show({
            canCancel: false,
          });
          axios.post('/account_settings/delete_redis_session/', qs.stringify(postData, {
            parseArrays: false
          }))
            .then(response => {
                
              loader.hide()
              if (response.data.message != 'success') {
                reject(response.data.message);
                return;
              }
            
              resolve(response.data);
            })
            .catch(error => console.log(error))
        });
      },
    
      deleteAllSessions({
        commit,
        dispatch
      }, postData) {
        return new Promise((resolve, reject) => {
    
          let loader = Vue.$loading.show({
            canCancel: false,
          });
          axios.post('/account_settings/delete_all_redis_session/', qs.stringify(postData, {
            parseArrays: false
          }))
            .then(response => {
              loader.hide()
              if (response.data.message != 'success') {
                reject(response.data.message);
                return;
              }
              resolve(response.data);
            })
            .catch(error => console.log(error))
        });
      },

}
const getters = {
    addLocationGetterstate: state => {
        return state.add_location
    },
    accountSettingGetter: state => {
        return state.account_setting_list
    },
    myZoneDetailsGetters: state => {
        return state.myZoneDetailsList
    },
    myZoneDetailsPermissionGetters: state => {
        return state.myZonePermissionsList
    },
}
export default {
    state,
    mutations,
    actions,
    getters
}

